import React from 'react';

import getImgxUrl from '@crehana/utils/dist/getImgxUrl';

import { ShoppingCartItem } from 'Jsx/CheckoutV4/types';
import PAYGBenefits from '../../../PAYGBenefits';

const CoursesAndBundlesDetail: React.FC<{
  productsList?: ShoppingCartItem[];
}> = ({ productsList }) => {
  if (!productsList) return null;

  return (
    <React.Fragment>
      <ul className="mt-24">
        {productsList?.map(product => (
          <li className="flex mb-16 " key={product?.id?.toString()}>
            <img
              src={getImgxUrl(product?.image, {
                w: 89,
                h: 60,
                dpr: 2,
                auto: 'format',
              })}
              width={89}
              height={60}
              alt="cover"
              className="flex-shrink-0 block object-cover rounded-5"
            />
            <div className="flex flex-col w-full ml-12">
              <p className="min-h-32 font-subtitle4">{product.title}</p>
            </div>
          </li>
        ))}
      </ul>
      <PAYGBenefits className="mt-20" />
    </React.Fragment>
  );
};

export default CoursesAndBundlesDetail;
